// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__fJUxV","text":"Pagination_text__ZOyH4","textOpacity":"Pagination_textOpacity__5FLr6","paginationListTop":"Pagination_paginationListTop__bT5z5"};